/*
 * @author: liaosir
 * @description: OBKoro1
 */
/**
 * @author: liaosir
 * @description: 根据入参value返回可复制的组件
 */
/**
 * @param value
 * @param len
 * @returns ReactNode
 * @example <Copy value={value} />
 */
import React from 'react';
import { Button, Message } from '@fpxfd/next';
import copy from 'copy-to-clipboard';
import styles from './index.module.scss';
import $i18n from 'panda-i18n';

interface Props {
  value: string | null;
  len?: number;
}

const Copy = ({ value, len = 50 }: Props) => {
  return !value || value?.length <= 0 ? (
    <></>
  ) : (
    <div className={styles.reqMsg}>
      <span title={value}>
        {value?.slice(0, len)}
        {len >= value?.length ? '' : '...'}
      </span>
      <Button
        type="primary"
        text
        size="medium"
        onClick={() => {
          copy(value);
          Message.success($i18n.get({ id: 'CopiedSuccessfully.four_px', dm: '复制成功' }));
        }}
      >
        {len >= value?.length ? '' : $i18n.get({ id: 'Copy.four_px', dm: '复制' })}
      </Button>
    </div>
  );
};

export default Copy;
